import React from 'react';
import cx from 'classnames';
import flatten from 'flat';
import { get, isEmpty } from 'lodash';

import { TabValidationStatuses } from 'enums';
import styles from './tabUtils.module.less';

export const getTabValidationIcon = (tabStatus: TabValidationStatuses) => {
  switch (tabStatus) {
    case TabValidationStatuses.Wait:
      return <span className={cx('icon icon-check-filled', styles.wait)} />;
    case TabValidationStatuses.Success:
      return <span className={cx('icon icon-check-filled', styles.success)} />;
    case TabValidationStatuses.Error:
      return <span className={cx('icon icon-closed-filled', styles.error)} />;
  }
};

export const getTabValidationStatus = (formik: any) => {
  const flattenErrors: any = flatten(formik.errors);

  const hasVisibleErrors = Object.keys(flattenErrors).some((key) =>
    get(formik.touched, key, false),
  );

  if (hasVisibleErrors) return TabValidationStatuses.Error;

  if (formik.isValid && !isEmpty(formik.touched))
    return TabValidationStatuses.Success;

  return TabValidationStatuses.Wait;
};
